export default "__VITE_ASSET___1hy2ms5__"